import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { IoClose } from "react-icons/io5";
import DownloadCreditReport from "../Download/DownloadCreditReport";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function DownloadReport({ handleCloseModal }) {
    const [countdown, setCountdown] = useState(5); // Countdown starts from 5

    const downloadRef = useRef();
    const [downloadLoading, setDownloadLoading] = useState(false);

    const handleButtonClick = async () => {
        if (downloadRef.current && downloadRef.current.triggerDownload) {
            setDownloadLoading(true);
            localStorage.setItem("downloadPdf", true)
            await downloadRef.current.triggerDownload();
            localStorage.setItem("downloadPdf", false)
            setDownloadLoading(false);
        }
    };
    // Function to start countdown and close modal after 5s
    const startCountdown = () => {
        let timeLeft = 3;
        setCountdown(timeLeft);

        const interval = setInterval(() => {
            timeLeft -= 1;
            setCountdown(timeLeft);

            if (timeLeft === 0) {
                clearInterval(interval);
                handleCloseModal(); // Close modal after 5s
                handleButtonClick()
            }
        }, 1000);
    };

    const handleClose = () => {
        handleCloseModal();
    };

    useEffect(() => {
        startCountdown()
    }, [])

    return (
        <div className="call-me-back-main">
            <>
                {/* <p>This service will be available soon; we are currently working on it.</p>
                <p>Closing in ({countdown}s)...</p> */}
                <p>Your download will start in ({countdown}s)...</p>
                {/* <button onClick={handleClose}>Close <IoClose /></button> */}
                {/* <button
                    onClick={handleButtonClick}
                    className="pdf-btn"
                    disabled={downloadLoading}
                    style={{ opacity: downloadLoading ? 0.6 : 1 }}
                >
                    {downloadLoading ? (
                        <h1>loading....</h1>
                    ) : (
                        'Download PDF'
                    )}
                </button> */}
                <div style={{ height: 10, width: 10, overflow: "hidden" }}>
                    <DownloadCreditReport ref={downloadRef} />
                </div>
            </>
        </div>
    );
}

export default DownloadReport;
